import { useState } from "react";
import {
  Button,
  TextField,
  Typography,
  Container,
  Link,
  Alert,
} from "@mui/material";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import { styled } from "@mui/system";
import logo from "../../logo.jpg";
import { useSignInQuery } from "../../api/useSignin";
import { useAuth } from "../../context/AuthContext";

const ContainerStyled = styled(Container)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",

  justifyContent: "center",
  height: "100%",
}));

const FormStyled = styled("form")(({ theme }) => ({
  marginTop: theme.spacing(1),
}));

const SubmitButtonStyled = styled(Button)(({ theme }) => ({
  margin: theme.spacing(3, 0, 2),
}));

const LogoStyled = styled("div")(({ theme }) => ({
  marginBottom: theme.spacing(2),
  textAlign: "center",
  // 로고 이미지 스타일링을 위한 스타일 추가
}));

const SignUpLinkStyled = styled(Typography)(({ theme }) => ({
  marginTop: theme.spacing(2),
}));

function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate(); // useNavigate 훅 사용
  const { mutate: signin, isPending, error } = useSignInQuery();
  const { currentUser, login } = useAuth(); // useAuth에서 login 함수 추출

  if (currentUser) {
    navigate("/");
  }

  const handleSignIn = (event) => {
    event.preventDefault();
    signin(
      { email, password },
      {
        onSuccess: (data) => {
          login(data.data);
          navigate("/"); // 로그인 성공 시 루트 경로로 리다이렉트
        },
        onError: (error) => {
          // 로그인 실패 시 처리 로직은 여기에 작성할 수 있습니다.
          // onError 콜백은 useMutation 옵션에 이미 포함되어 있으므로, 필요에 따라 추가적인 처리를 해줄 수 있습니다.
          console.error("로그인 실패:", error);
          setErrorMessage(error.response.data.error);
        },
      }
    );
  };

  return (
    <ContainerStyled component="main" maxWidth="xs">
      <LogoStyled>
        <img src={logo} alt="Logo" width={100} />
        <Typography component="h1" variant="h5">
          코딩알려주는 누나 스터디
        </Typography>
      </LogoStyled>
      <FormStyled noValidate onSubmit={handleSignIn}>
        {error && <Alert severity="error">{errorMessage}</Alert>}
        <TextField
          variant="outlined"
          margin="normal"
          required
          fullWidth
          id="email"
          label="이메일 주소"
          name="email"
          autoComplete="email"
          autoFocus
          onChange={(e) => setEmail(e.target.value.trim())}
        />
        <TextField
          variant="outlined"
          margin="normal"
          required
          fullWidth
          name="password"
          label="비밀번호"
          type="password"
          id="password"
          autoComplete="current-password"
          onChange={(e) => setPassword(e.target.value.trim())}
        />
        {isPending ? (
          <div>Loading...</div>
        ) : (
          <SubmitButtonStyled type="submit" fullWidth variant="contained">
            로그인
          </SubmitButtonStyled>
        )}

        <SignUpLinkStyled variant="body2" color="textSecondary" align="center">
          회원이 아니신가요?{" "}
          <Link component={RouterLink} to="/signup" variant="body2">
            회원가입
          </Link>
        </SignUpLinkStyled>
      </FormStyled>
    </ContainerStyled>
  );
}

export default LoginPage;
